var _circle, _path, _rect, _rect2, _rect3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBoleto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9246 21.8543L56.4978 19.0174C56.6859 18.81 56.9529 18.6917 57.2329 18.6917C57.5129 18.6917 57.7799 18.81 57.968 19.0174L60.5412 21.8543L63.1143 19.0174C63.3899 18.7136 63.8241 18.6106 64.2068 18.7583C64.5895 18.906 64.8419 19.274 64.8419 19.6842V68.3158C64.8419 68.726 64.5895 69.094 64.2068 69.2417C63.8241 69.3894 63.3899 69.2864 63.1143 68.9826L60.5412 66.1457L57.968 68.9826C57.7799 69.19 57.5129 69.3083 57.2329 69.3083C56.9529 69.3083 56.6859 69.19 56.4978 68.9826L53.9246 66.1457L51.3515 68.9826C51.1634 69.19 50.8964 69.3083 50.6164 69.3083C50.3363 69.3083 50.0694 69.19 49.8812 68.9826L47.3081 66.1457L44.735 68.9826C44.5468 69.19 44.2798 69.3083 43.9998 69.3083C43.7198 69.3083 43.4528 69.19 43.2647 68.9826L40.6916 66.1457L38.1184 68.9826C37.9303 69.19 37.6633 69.3083 37.3833 69.3083C37.1033 69.3083 36.8363 69.19 36.6481 68.9826L34.075 66.1457L31.5019 68.9826C31.3137 69.19 31.0468 69.3083 30.7667 69.3083C30.4867 69.3083 30.2197 69.19 30.0316 68.9826L27.4585 66.1457L24.8853 68.9826C24.6097 69.2864 24.1756 69.3894 23.7928 69.2417C23.4101 69.094 23.1577 68.726 23.1577 68.3158V19.6842C23.1577 19.274 23.4101 18.906 23.7928 18.7583C24.1756 18.6106 24.6097 18.7136 24.8853 19.0174L27.4585 21.8543L30.0316 19.0174C30.2197 18.81 30.4867 18.6917 30.7667 18.6917C31.0468 18.6917 31.3137 18.81 31.5019 19.0174L34.075 21.8543L36.6481 19.0174C36.8363 18.81 37.1033 18.6917 37.3833 18.6917C37.6633 18.6917 37.9303 18.81 38.1184 19.0174L40.6916 21.8543L43.2647 19.0174C43.4528 18.81 43.7198 18.6917 43.9998 18.6917C44.2798 18.6917 44.5468 18.81 44.735 19.0174L47.3081 21.8543L49.8812 19.0174C50.0694 18.81 50.3363 18.6917 50.6164 18.6917C50.8964 18.6917 51.1634 18.81 51.3515 19.0174L53.9246 21.8543Z",
    fill: "#6BC9FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.1201,
    y: 42.015,
    width: 3.96992,
    height: 19.8496,
    rx: 1.98496,
    transform: "rotate(-90 28.1201 42.015)",
    fill: "#E5F3FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1201,
    y: 49.9549,
    width: 3.96992,
    height: 31.7594,
    rx: 1.98496,
    transform: "rotate(-90 28.1201 49.9549)",
    fill: "#E5F3FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1201,
    y: 57.8947,
    width: 3.96992,
    height: 19.8496,
    rx: 1.98496,
    transform: "rotate(-90 28.1201 57.8947)",
    fill: "#E5F3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9099 26.1353L58.717 27.2981L59.8798 30.1053L58.717 32.9124L55.9099 34.0752L53.1027 32.9124L51.9399 30.1053L53.1027 27.2981L55.9099 26.1353Z",
    fill: "#FCC830"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoleto);
export default __webpack_public_path__ + "static/media/ic_boleto.8abb54f48cbd67204b144befa72fcdd7.svg";
export { ForwardRef as ReactComponent };